import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './i18n';
import { initGA, trackPageView } from './utils/analytics';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import ScrollToTop from './components/Common/ScrollToTop';
import Home from './pages/Home';
import PageTemplate from './components/Common/PageTemplate';
import About from './pages/About';
import Contact from './pages/Contact';
import News from './pages/NewsPage';
import AnitkabirZiyareti2025 from './pages/haberler/2024-2025-akademik-yili-fen-fakultesi-mezunlari-anitkabir-ziyareti';
import ErasmusCagliari from './pages/haberler/hacettepe-universitesi-erasmus-programi-cagliari';
import MezuniyetToreni2025 from './pages/haberler/2025-yili-mezuniyet-toreni';
import Tubitak1001Sonuclari from './pages/haberler/Tubitak1001Sonuclari';
import ProfAsliOzkokFaoProje from './pages/haberler/prof-dr-asli-ozkok-saban-fao-projesinde-ulusal-uzman-egitimci-secildi';
import BeyazOnlukToreni from './pages/haberler/hacettepe-universitesi-kimya-bolumu-3-beyaz-onluk-giyme-toreni-gerceklestirildi';
import AsaInternationalDataQuest2025 from './pages/haberler/asa-international-data-quest-2025-cifte-turkiye-birinciligi';
import DavutAksutUSMZiyareti from './pages/haberler/davut-aksut-universiti-sains-malaysia-ziyareti';
import BeytepGoleteleriAcigolKorumaProjesi from './pages/haberler/beytepe-goletleri-acigol-dislisazancigi-koruma-projesi';
import Events from './pages/EventsPage';
import Publications from './pages/PublicationsPage';
import Announcements from './pages/Announcements';
import AnnouncementDetail from './pages/AnnouncementDetail';
import Etkinlikler from './pages/Etkinlikler';
import BirimFaaliyetleri from './pages/BirimFaaliyetleri';
import Videogaleri from './pages/Videogaleri';

// Kurumsal Sayfalar
import History from './pages/Institutional/History';
import Mission from './pages/Institutional/Mission';
import MissionVision from './pages/Institutional/MissionVision';
import FEDEK from './pages/Institutional/FEDEK';
import StrategicPlan from './pages/Institutional/StrategicPlan';
import FormerDeans from './pages/Institutional/FormerDeans';
import EngelsizYasam from './pages/EngelsizYasam';

// Yönetim Sayfaları
import Dean from './pages/Management/Dean';
import ViceDeans from './pages/Management/ViceDeans';
import FacultyBoard from './pages/Management/FacultyBoard';
import ManagementBoard from './pages/Management/ManagementBoard';
import FacultySecretaries from './pages/Management/FacultySecretaries';
import FakulteSekreteri from './pages/Management/FakulteSekreteri';
import ManagementScheme from './pages/Management/ManagementScheme';
import QualityStrategy from './pages/Management/QualityStrategy';
import AcademicQualityCommission from './pages/Management/AcademicQualityCommission';
import ScholarshipCommission from './pages/Management/ScholarshipCommission';
import PromotionCeremonyCommission from './pages/Management/PromotionCeremonyCommission';
import PublicationCommission from './pages/Management/PublicationCommission';
import NonFormalLearningCommission from './pages/Management/NonFormalLearningCommission';
import BirimDanismaKurulu from './pages/Management/BirimDanismaKurulu';

// Personel Sayfaları
import Faculty from './pages/Staff/Faculty';
import TeachingStaff from './pages/Staff/TeachingStaff';
import ResearchStaff from './pages/Staff/ResearchStaff';
import RetiredStaff from './pages/Staff/RetiredStaff';

// Belge Sayfaları
import AcademicStaff from './pages/Documents/AcademicStaff';
import Students from './pages/Documents/Students';
import Laws from './pages/Documents/Laws';

// Karar Sayfaları
import FacultyBoardDecisions from './pages/Decisions/FacultyBoardDecisions';
import FacultyManagementBoardDecisions from './pages/Decisions/FacultyManagementBoardDecisions';
import FacultyBoard2025 from './pages/Decisions/FacultyBoard2025';
import FacultyBoard2024 from './pages/Decisions/FacultyBoard2024';
import FacultyBoard2023 from './pages/Decisions/FacultyBoard2023';
import FacultyBoard2022 from './pages/Decisions/FacultyBoard2022';
import FacultyManagementBoard2025 from './pages/Decisions/FacultyManagementBoard2025';
import FacultyManagementBoard2024 from './pages/Decisions/FacultyManagementBoard2024';
import FacultyManagementBoard2023 from './pages/Decisions/FacultyManagementBoard2023';
import FacultyManagementBoard2022 from './pages/Decisions/FacultyManagementBoard2022';

// Staff pages
import FacultyMembers from './pages/Staff/FacultyMembers';
import LecturingStaff from './pages/Staff/LecturingStaff';
import ResearchAssistants from './pages/Staff/ResearchAssistants';
import AdministrativeStaff from './pages/Staff/AdministrativeStaff';
import RetiredFaculty from './pages/Staff/RetiredFaculty';

// Araştırma Sayfaları
import ResearchLabs from './pages/Research/ResearchLabs';
import BooksAndJournals from './pages/Research/BooksAndJournals';
import DergilerPage from './pages/Research/Dergiler';
import Museums from './pages/Research/Museums';
import DevamEdenProjeler from './pages/Research/DevamEdenProjeler';
import DisDestekliProjeler from './pages/Research/DisDestekliProjeler';
import BAPDestekliProjeler from './pages/Research/BAPDestekliProjeler';

// Bölüm Sayfaları
import Biology from './pages/Departments/Biology';
import BiologyFaculty from './pages/Departments/BiologyFaculty';
import Mathematics from './pages/Departments/Mathematics';
import Statistics from './pages/Departments/Statistics';
import ActuarialScience from './pages/Departments/ActuarialScience';
import KimyaBolumuSanalTur from './pages/Departments/KimyaBolumuSanalTur';

// Mezun Sayfaları
import AlumniPage from './pages/AlumniPage';
import Graduates from './pages/Graduates/Graduates';

// Galeri
import GalleryPage from './pages/GalleryPage';
import AlbumListPage from './pages/AlbumListPage';
import AlbumDetailPage from './pages/AlbumDetailPage';

// Dinamik Sayfa
import DynamicPage from './pages/DynamicPage';

// Öğrenci Toplulukları
import StudentClubs from './pages/StudentClubs/StudentClubs';
import OgrenciTopluluklari from './pages/OgrenciTopluluklari';

// Programlar
import UndergraduateProgramsPage from './pages/Programs/Undergraduate';
import ErasmusPage from './pages/Programs/Erasmus';
import ErasmusOgrenciDeneyimleri from './pages/Programs/ErasmusOgrenciDeneyimleri';
import YandalPage from './pages/Programs/Yandal';
import CiftAnadalPage from './pages/Programs/CiftAnadal';
import YuksekLisansPage from './pages/Programs/YuksekLisans';
import DoktoraPage from './pages/Programs/Doktora';

// Staj
import StajPage from './pages/Staj';

// Uluslararası Öğrenciler
import UluslararasiOgrenciler from './pages/Student/UluslararasiOgrenciler';

// Sosyal Sorumluluk
import SosyalSorumlulukProjeleri from './pages/SosyalSorumlulukProjeleri';

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

function LanguageWrapper({ children }) {
    const location = useLocation();
    const { i18n } = useTranslation();

    // İlk mount'ta localStorage temizle
    useEffect(() => {
        try {
            localStorage.clear();
        } catch (e) {}
    }, []); // Sadece ilk renderda

    // URL değiştiğinde dili güncelle
    useEffect(() => {
        const isEnglish = location.pathname.startsWith('/en/') || location.pathname === '/en';
        const targetLang = isEnglish ? 'en' : 'tr';

        // Sadece farklıysa değiştir
        if (i18n.language !== targetLang) {
            i18n.changeLanguage(targetLang);
        }

        document.documentElement.lang = targetLang;
    }, [location.pathname]); // i18n'i dependency'den çıkar

    return <>{children}</>;
}

function AppContent() {
    const location = useLocation();

    // Google Analytics sayfa takibi
    useEffect(() => {
        // İlk yükleme için GA'yi başlat
        if (location.pathname === '/' || location.pathname === '/en') {
            initGA();
        }

        // Her sayfa değişiminde track et
        const pageTitle = document.title || 'Hacettepe Üniversitesi Fen Fakültesi';
        trackPageView(location.pathname + location.search, pageTitle);
    }, [location]);

    return (
        <LanguageWrapper>
            <ScrollToTop />
            <div className="flex flex-col min-h-screen flow-bg">
                <Navbar />
                <main className="flex-grow">
                    <Routes>
                    {/* Turkish routes */}
                    <Route path="/" element={<Home />} />
                    <Route path="/hakkimizda" element={<About />} />
                    <Route path="/iletisim" element={<Contact />} />

                    {/* English routes */}
                    <Route path="/en" element={<Home />} />
                    <Route path="/en/hakkimizda" element={<About />} />
                    <Route path="/en/iletisim" element={<Contact />} />
                    
                    <Route path="/haberler" element={<News />} />
                    <Route path="/en/haberler" element={<News />} />
                    <Route path="/haberler/2024-2025-akademik-yili-fen-fakultesi-mezunlari-anitkabir-ziyareti" element={<AnitkabirZiyareti2025 />} />
                    <Route path="/haberler/hacettepe-universitesi-erasmus-programi-cagliari" element={<ErasmusCagliari />} />
                    <Route path="/haberler/2025-yili-mezuniyet-toreni" element={<MezuniyetToreni2025 />} />
                    <Route path="/haberler/tubitak-1001-programi-2025-yili-1-donem-degerlendirme-sonuclari-aciklandi" element={<Tubitak1001Sonuclari />} />
                    <Route path="/haberler/prof-dr-asli-ozkok-saban-fao-projesinde-ulusal-uzman-egitimci-secildi" element={<ProfAsliOzkokFaoProje />} />
                    <Route path="/haberler/hacettepe-universitesi-kimya-bolumu-3-beyaz-onluk-giyme-toreni-gerceklestirildi" element={<BeyazOnlukToreni />} />
                    <Route path="/haberler/asa-international-data-quest-2025-cifte-turkiye-birinciligi" element={<AsaInternationalDataQuest2025 />} />
                    <Route path="/haberler/davut-aksut-universiti-sains-malaysia-ziyareti" element={<DavutAksutUSMZiyareti />} />
                    <Route path="/haberler/beytepe-goletleri-acigol-dislisazancigi-koruma-projesi" element={<BeytepGoleteleriAcigolKorumaProjesi />} />
                    <Route path="/etkinlikler" element={<Etkinlikler />} />
                    <Route path="/en/etkinlikler" element={<Etkinlikler />} />
                    <Route path="/yayinlar" element={<Publications />} />
                    <Route path="/en/yayinlar" element={<Publications />} />
                    <Route path="/duyurular" element={<Announcements />} />
                    <Route path="/en/duyurular" element={<Announcements />} />
                    <Route path="/duyurular/:id" element={<AnnouncementDetail />} />
                    <Route path="/en/duyurular/:id" element={<AnnouncementDetail />} />
                    <Route path="/galeri" element={<AlbumListPage />} />
                    <Route path="/en/galeri" element={<AlbumListPage />} />
                    <Route path="/albums" element={<AlbumListPage />} />
                    <Route path="/en/albums" element={<AlbumListPage />} />
                    <Route path="/albums/:albumId" element={<AlbumDetailPage />} />
                    <Route path="/en/albums/:albumId" element={<AlbumDetailPage />} />
                    <Route path="/videogaleri" element={<Videogaleri />} />
                    <Route path="/en/videogaleri" element={<Videogaleri />} />

                    <Route path="/kurumsal/tarihce" element={<History />} />
                    <Route path="/en/kurumsal/tarihce" element={<History />} />
                    <Route path="/kurumsal/misyon-vizyon" element={<MissionVision />} />
                    <Route path="/en/kurumsal/misyon-vizyon" element={<MissionVision />} />
                    <Route path="/kurumsal/fedek" element={<FEDEK />} />
                    <Route path="/en/kurumsal/fedek" element={<FEDEK />} />
                    <Route path="/kurumsal/stratejik-plan" element={<StrategicPlan />} />
                    <Route path="/en/kurumsal/stratejik-plan" element={<StrategicPlan />} />
                    <Route path="/kurumsal/eski-dekanlar" element={<FormerDeans />} />
                    <Route path="/en/kurumsal/eski-dekanlar" element={<FormerDeans />} />
                    <Route path="/engelsiz-yasam" element={<EngelsizYasam />} />
                    <Route path="/en/engelsiz-yasam" element={<EngelsizYasam />} />

                    <Route path="/yonetim/dekan" element={<Dean />} />
                    <Route path="/en/yonetim/dekan" element={<Dean />} />
                    <Route path="/yonetim/dekan-yardimcilari" element={<ViceDeans />} />
                    <Route path="/en/yonetim/dekan-yardimcilari" element={<ViceDeans />} />
                    <Route path="/yonetim/fakulte-kurulu" element={<FacultyBoard />} />
                    <Route path="/en/yonetim/fakulte-kurulu" element={<FacultyBoard />} />
                    <Route path="/yonetim/yonetim-kurulu" element={<ManagementBoard />} />
                    <Route path="/en/yonetim/yonetim-kurulu" element={<ManagementBoard />} />
                    <Route path="/yonetim/fakulte-sekreterleri" element={<FacultySecretaries />} />
                    <Route path="/en/yonetim/fakulte-sekreterleri" element={<FacultySecretaries />} />
                    <Route path="/yonetim/fakulte-sekreteri" element={<FakulteSekreteri />} />
                    <Route path="/en/yonetim/fakulte-sekreteri" element={<FakulteSekreteri />} />
                    <Route path="/yonetim/yonetim-semasi" element={<ManagementScheme />} />
                    <Route path="/en/yonetim/yonetim-semasi" element={<ManagementScheme />} />

                    <Route path="/kurul-komisyonlar/birim-danisma-kurulu" element={<BirimDanismaKurulu />} />
                    <Route path="/en/kurul-komisyonlar/birim-danisma-kurulu" element={<BirimDanismaKurulu />} />
                    <Route path="/kurul-komisyonlar/kalite-strateji" element={<QualityStrategy />} />
                    <Route path="/en/kurul-komisyonlar/kalite-strateji" element={<QualityStrategy />} />
                    <Route path="/kurul-komisyonlar/akademik-birim-kalite" element={<AcademicQualityCommission />} />
                    <Route path="/en/kurul-komisyonlar/akademik-birim-kalite" element={<AcademicQualityCommission />} />
                    <Route path="/kurul-komisyonlar/burs-komisyonu" element={<ScholarshipCommission />} />
                    <Route path="/en/kurul-komisyonlar/burs-komisyonu" element={<ScholarshipCommission />} />
                    <Route path="/kurul-komisyonlar/tanitim-toren" element={<PromotionCeremonyCommission />} />
                    <Route path="/en/kurul-komisyonlar/tanitim-toren" element={<PromotionCeremonyCommission />} />
                    <Route path="/kurul-komisyonlar/yayin" element={<PublicationCommission />} />
                    <Route path="/en/kurul-komisyonlar/yayin" element={<PublicationCommission />} />
                    <Route path="/kurul-komisyonlar/program-disi-ogrenme" element={<NonFormalLearningCommission />} />
                    <Route path="/en/kurul-komisyonlar/program-disi-ogrenme" element={<NonFormalLearningCommission />} />

                    <Route path="/personel/akademisyen" element={<Faculty />} />
                    <Route path="/en/personel/akademisyen" element={<Faculty />} />
                    <Route path="/personel/ogretim-gorevlisi" element={<TeachingStaff />} />
                    <Route path="/en/personel/ogretim-gorevlisi" element={<TeachingStaff />} />
                    <Route path="/personel/idari-personel" element={<AdministrativeStaff />} />
                    <Route path="/en/personel/idari-personel" element={<AdministrativeStaff />} />
                    <Route path="/personel/arastirma-gorevlisi" element={<ResearchStaff />} />
                    <Route path="/en/personel/arastirma-gorevlisi" element={<ResearchStaff />} />
                    <Route path="/personel/emekli-personel" element={<RetiredStaff />} />
                    <Route path="/en/personel/emekli-personel" element={<RetiredStaff />} />

                    <Route path="/belgeler/akademik-personel" element={<AcademicStaff />} />
                    <Route path="/en/belgeler/akademik-personel" element={<AcademicStaff />} />
                    <Route path="/belgeler/ogrenciler" element={<Students />} />
                    <Route path="/en/belgeler/ogrenciler" element={<Students />} />
                    <Route path="/belgeler/kanun-yonetmelikler" element={<Laws />} />
                    <Route path="/en/belgeler/kanun-yonetmelikler" element={<Laws />} />
                    <Route path="/belgeler/akademik-idari-personel" element={<AcademicStaff />} />
                    <Route path="/en/belgeler/akademik-idari-personel" element={<AcademicStaff />} />
                    <Route path="/belgeler/ogrenci" element={<Students />} />
                    <Route path="/en/belgeler/ogrenci" element={<Students />} />
                    <Route path="/belgeler/gerekli-belge-formlar" element={<PageTemplate title="Gerekli Belge ve Formlar"><div className="text-center text-gray-600">Bu sayfa yakında güncellenecektir.</div></PageTemplate>} />
                    <Route path="/en/belgeler/gerekli-belge-formlar" element={<PageTemplate title="Required Documents and Forms"><div className="text-center text-gray-600">This page will be updated soon.</div></PageTemplate>} />

                    <Route path="/kararlar/fakulte-kurulu" element={<FacultyBoardDecisions />} />
                    <Route path="/en/kararlar/fakulte-kurulu" element={<FacultyBoardDecisions />} />
                    <Route path="/kararlar/fakulte-kurulu/2025" element={<FacultyBoard2025 />} />
                    <Route path="/en/kararlar/fakulte-kurulu/2025" element={<FacultyBoard2025 />} />
                    <Route path="/kararlar/fakulte-kurulu/2024" element={<FacultyBoard2024 />} />
                    <Route path="/en/kararlar/fakulte-kurulu/2024" element={<FacultyBoard2024 />} />
                    <Route path="/kararlar/fakulte-kurulu/2023" element={<FacultyBoard2023 />} />
                    <Route path="/en/kararlar/fakulte-kurulu/2023" element={<FacultyBoard2023 />} />
                    <Route path="/kararlar/fakulte-kurulu/2022" element={<FacultyBoard2022 />} />
                    <Route path="/en/kararlar/fakulte-kurulu/2022" element={<FacultyBoard2022 />} />
                    <Route path="/kararlar/fakulte-yonetim" element={<FacultyManagementBoardDecisions />} />
                    <Route path="/en/kararlar/fakulte-yonetim" element={<FacultyManagementBoardDecisions />} />
                    <Route path="/kararlar/fakulte-yonetim/2025" element={<FacultyManagementBoard2025 />} />
                    <Route path="/en/kararlar/fakulte-yonetim/2025" element={<FacultyManagementBoard2025 />} />
                    <Route path="/kararlar/fakulte-yonetim/2024" element={<FacultyManagementBoard2024 />} />
                    <Route path="/en/kararlar/fakulte-yonetim/2024" element={<FacultyManagementBoard2024 />} />
                    <Route path="/kararlar/fakulte-yonetim/2023" element={<FacultyManagementBoard2023 />} />
                    <Route path="/en/kararlar/fakulte-yonetim/2023" element={<FacultyManagementBoard2023 />} />
                    <Route path="/kararlar/fakulte-yonetim/2022" element={<FacultyManagementBoard2022 />} />
                    <Route path="/en/kararlar/fakulte-yonetim/2022" element={<FacultyManagementBoard2022 />} />

                    <Route path="/fakulte-personeli/ogretim-uyeleri" element={<FacultyMembers />} />
                    <Route path="/en/fakulte-personeli/ogretim-uyeleri" element={<FacultyMembers />} />
                    <Route path="/fakulte-personeli/ogretim-gorevlileri" element={<LecturingStaff />} />
                    <Route path="/en/fakulte-personeli/ogretim-gorevlileri" element={<LecturingStaff />} />
                    <Route path="/fakulte-personeli/arastirma-gorevlileri" element={<ResearchAssistants />} />
                    <Route path="/en/fakulte-personeli/arastirma-gorevlileri" element={<ResearchAssistants />} />
                    <Route path="/fakulte-personeli/idari-personel" element={<AdministrativeStaff />} />
                    <Route path="/en/fakulte-personeli/idari-personel" element={<AdministrativeStaff />} />
                    <Route path="/fakulte-personeli/emekli-ogretim-elemanlari" element={<RetiredFaculty />} />
                    <Route path="/en/fakulte-personeli/emekli-ogretim-elemanlari" element={<RetiredFaculty />} />

                    <Route path="/arastirma/laboratuvarlar" element={<ResearchLabs />} />
                    <Route path="/en/arastirma/laboratuvarlar" element={<ResearchLabs />} />
                    <Route path="/arastirma/kitaplar-dergiler" element={<BooksAndJournals />} />
                    <Route path="/en/arastirma/kitaplar-dergiler" element={<BooksAndJournals />} />
                    <Route path="/arastirma/kitaplar-editorlukler" element={<BooksAndJournals />} />
                    <Route path="/en/arastirma/kitaplar-editorlukler" element={<BooksAndJournals />} />
                    <Route path="/arastirma/dergiler" element={<DergilerPage />} />
                    <Route path="/en/arastirma/dergiler" element={<DergilerPage />} />
                    <Route path="/arastirma/muzeler" element={<Museums />} />
                    <Route path="/en/arastirma/muzeler" element={<Museums />} />
                    <Route path="/arastirma/devam-eden-projelerimiz" element={<DevamEdenProjeler />} />
                    <Route path="/en/arastirma/devam-eden-projelerimiz" element={<DevamEdenProjeler />} />
                    <Route path="/arastirma/devam-eden-projelerimiz/dis-destekli" element={<DisDestekliProjeler />} />
                    <Route path="/en/arastirma/devam-eden-projelerimiz/dis-destekli" element={<DisDestekliProjeler />} />
                    <Route path="/arastirma/devam-eden-projelerimiz/bap-destekli" element={<BAPDestekliProjeler />} />
                    <Route path="/en/arastirma/devam-eden-projelerimiz/bap-destekli" element={<BAPDestekliProjeler />} />

                    <Route path="/bolumler/biyoloji/*" element={<Biology />} />
                    <Route path="/en/bolumler/biyoloji/*" element={<Biology />} />
                    <Route path="/bolumler/biyoloji/ogretim-uyeleri" element={<BiologyFaculty />} />
                    <Route path="/en/bolumler/biyoloji/ogretim-uyeleri" element={<BiologyFaculty />} />
                    <Route path="/bolumler/matematik" element={<Mathematics />} />
                    <Route path="/en/bolumler/matematik" element={<Mathematics />} />
                    <Route path="/bolumler/istatistik" element={<Statistics />} />
                    <Route path="/en/bolumler/istatistik" element={<Statistics />} />
                    <Route path="/bolumler/aktuerya-bilimleri" element={<ActuarialScience />} />
                    <Route path="/en/bolumler/aktuerya-bilimleri" element={<ActuarialScience />} />
                    <Route path="/bolumler/kimya-bolumu-sanal-tur" element={<KimyaBolumuSanalTur />} />
                    <Route path="/en/bolumler/kimya-bolumu-sanal-tur" element={<KimyaBolumuSanalTur />} />

                    <Route path="/mezunlar" element={<Graduates />} />
                    <Route path="/en/mezunlar" element={<Graduates />} />
                    <Route path="/mezunlar/liste" element={<Graduates />} />
                    <Route path="/en/mezunlar/liste" element={<Graduates />} />
                    <Route path="/mezunlar/basari-hikayeleri" element={<PageTemplate title="Başarı Hikayeleri"><div className="text-center text-gray-600">Bu sayfa yakında güncellenecektir.</div></PageTemplate>} />
                    <Route path="/en/mezunlar/basari-hikayeleri" element={<PageTemplate title="Success Stories"><div className="text-center text-gray-600">This page will be updated soon.</div></PageTemplate>} />
                    <Route path="/mezunlar/iletisim" element={<PageTemplate title="Mezun İletişim"><div className="text-center text-gray-600">Bu sayfa yakında güncellenecektir.</div></PageTemplate>} />
                    <Route path="/en/mezunlar/iletisim" element={<PageTemplate title="Alumni Contact"><div className="text-center text-gray-600">This page will be updated soon.</div></PageTemplate>} />
                    <Route path="/yuksek-lisans" element={<Graduates />} />
                    <Route path="/en/yuksek-lisans" element={<Graduates />} />
                    <Route path="/doktora" element={<Graduates />} />
                    <Route path="/en/doktora" element={<Graduates />} />
                    <Route path="/alumni" element={<AlumniPage />} />
                    <Route path="/en/alumni" element={<AlumniPage />} />

                    <Route path="/sayfa/:slug" element={<DynamicPage />} />
                    <Route path="/en/sayfa/:slug" element={<DynamicPage />} />

                    <Route path="/ogrenci-topluluklari" element={<OgrenciTopluluklari />} />
                    <Route path="/en/ogrenci-topluluklari" element={<OgrenciTopluluklari />} />
                    <Route path="/ogrenci-toplulukları-old" element={<StudentClubs />} />
                    <Route path="/en/ogrenci-toplulukları-old" element={<StudentClubs />} />

                    <Route path="/programlar/lisans" element={<UndergraduateProgramsPage />} />
                    <Route path="/en/programlar/lisans" element={<UndergraduateProgramsPage />} />
                    <Route path="/programlar/erasmus" element={<ErasmusPage />} />
                    <Route path="/en/programlar/erasmus" element={<ErasmusPage />} />
                    <Route path="/programlar/erasmus/ogrenci-deneyimleri" element={<ErasmusOgrenciDeneyimleri />} />
                    <Route path="/en/programlar/erasmus/ogrenci-deneyimleri" element={<ErasmusOgrenciDeneyimleri />} />
                    <Route path="/programlar/yandal" element={<YandalPage />} />
                    <Route path="/en/programlar/yandal" element={<YandalPage />} />
                    <Route path="/programlar/cift-anadal" element={<CiftAnadalPage />} />
                    <Route path="/en/programlar/cift-anadal" element={<CiftAnadalPage />} />
                    <Route path="/programlar/yuksek-lisans" element={<YuksekLisansPage />} />
                    <Route path="/en/programlar/yuksek-lisans" element={<YuksekLisansPage />} />
                    <Route path="/programlar/doktora" element={<DoktoraPage />} />
                    <Route path="/en/programlar/doktora" element={<DoktoraPage />} />

                    <Route path="/staj" element={<StajPage />} />
                    <Route path="/en/staj" element={<StajPage />} />

                    <Route path="/ogrenci/uluslararasi-ogrenciler" element={<UluslararasiOgrenciler />} />
                    <Route path="/en/student/international-students" element={<UluslararasiOgrenciler />} />

                    <Route path="/sosyal-sorumluluk-projeleri" element={<SosyalSorumlulukProjeleri />} />
                    <Route path="/en/sosyal-sorumluluk-projeleri" element={<SosyalSorumlulukProjeleri />} />

                    <Route path="/birim-faaliyetleri" element={<BirimFaaliyetleri />} />
                    <Route path="/en/birim-faaliyetleri" element={<BirimFaaliyetleri />} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </LanguageWrapper>
    );
}

export default App; 